<ng-container *transloco="let t; read: 'notices'">

  <div class="main-content" *ngIf="ac !== null">
    <h1><app-back-button></app-back-button>{{ t('notices') }}</h1>
    <div class="layout-content">
      <div class="acr-card-body">

        <app-candidate-selector
          *ngIf="!auth.isCandidate()"
          [candidate]="candidate"
          (candidateChange)="changeCandidate($event)"
        ></app-candidate-selector>

        <ng-container *ngIf="!ac.isFinished()">
          <editor *ngIf="candidate === null" style="width: 100%; height: calc(100% - 90px)" [formControl]="form.get('general')" [init]="getEditorInit()"></editor>
          <ng-container *ngFor="let actual of ac.candidates">
            <editor *ngIf="candidate !== null && actual.id === candidate.hashed_id" style="width: 100%; height: calc(100% - 90px)" [formControl]="form.get(actual.hashed_id)" [init]="getEditorInit()"></editor>
          </ng-container>
          <p class="hint">{{ t('accessibility') }}</p>
        </ng-container>

        <div *ngIf="ac.isFinished()">
          <div *ngIf="candidate === null" [innerHtml]="form.get('general').value"></div>
          <ng-container *ngFor="let actual of ac.candidates">
            <div *ngIf="candidate !== null && actual.id === candidate.hashed_id" [innerHtml]="form.get(candidate.hashed_id).value"></div>
          </ng-container>
        </div>

      </div>
    </div>
  </div>

</ng-container>
